import { useContext } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import PageHero from "../components/PageHero";
import Rooms from "../components/Rooms";
import HotelDetails from "../components/HotelDetails";
import { LanguageContext } from "../App";
import { IMAGES } from "../translations";

export default function RoomsPage() {
  const { t } = useContext(LanguageContext);

  return (
    <>
      <PageHero
        image={IMAGES.rooms_hero}
        overline={t.rooms.overline}
        title={t.rooms.headline}
        subtitle={t.rooms.subtext}
      />
      <Rooms showBooking={true} hideHeader={true} />
      <HotelDetails />

      {/* Booking CTA */}
      <section className="bg-[#EBE8E0] py-16 px-6 text-center" data-testid="rooms-cta-section">
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.8 }}
        >
          <Link
            to="/prenota"
            data-testid="rooms-page-book-btn"
            className="inline-flex items-center justify-center bg-[#7B907F] text-white font-['Manrope',sans-serif] text-xs uppercase tracking-[0.25em] w-full sm:w-auto px-12 py-5 hover:bg-[#687A6C] transition-all duration-300"
          >
            {t.contact.cta_button}
          </Link>
        </motion.div>
      </section>
    </>
  );
}
